import React, { useEffect } from "react";
import Header from "./header/Header";
import Footer from "./footer/Footer";
import "./../App.css";
import "./PageLayout.css";

const PageLayout = ({ children }) => {
    useEffect(() => {
        // Dynamische Berechnung der Header- und Footer-Höhe
        const header = document.querySelector(".header");
        const footer = document.querySelector(".footer");
        if (header && footer) {
            document.documentElement.style.setProperty(
                "--header-height",
                `${header.offsetHeight}px`
            );
            document.documentElement.style.setProperty(
                "--footer-height",
                `${footer.offsetHeight}px`
            );
        }
    }, []);

    return (
        <div className="PageLayout">
            <Header />
            <div className="main-content">{children}</div>
            <Footer />
        </div>
    );
};

export default PageLayout;
